module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/merchant_activity_new_04.png";